import gql from 'graphql-tag';

export const EventDetailsFragment = gql`
  fragment EventDetailsFragment on Event {
    id
    type
    displayType
    dataType
    title
    subtitle
    content
    relatedRound
    date {
      startDate
      endDate
    }
    eventIds
    eventDetails {
      ... on AdmissionRound {
        id
        projectName
        applicationDate {
          startDate
          endDate
        }
      }
      ... on Exam {
        id
      }
    }
  }
`;

export const SmallEventDetailsFragment = gql`
  fragment SmallEventDetailsFragment on Event {
    id
    type
    displayType
    dataType
    title
    subtitle
    content
    relatedRound
    date {
      startDate
      endDate
    }
    eventIds
  }
`;
